import React from "react";
import { appDomain, appSubscribe } from "../../domain/AppDomain";
import { IEventSubscription } from "../../domain/events/IEventHandler";

export class BaseComponent<P = {}, S = {}, SS = any> extends React.Component<P, S, SS> {
    private _unmounted = false;
    private _subscriptions: IEventSubscription[];
    constructor(props: P) {
        super(props);
        this._subscriptions = [];
    }

    setStateWhenMounted<K extends keyof S>(state: ((prevState: Readonly<S>, props: Readonly<P>) => (Pick<S, K> | S | null)) | (Pick<S, K> | S | null), callback?: () => void): void {
        if (this.mounted()) {
            this.setState(state, callback);
        }
    }

    mounted() {
        return !this._unmounted;
    }

    componentDidMount() {
        // add mount code
    }

    componentWillUnmount() {
        this._unmounted = true;
        this._subscriptions.forEach(s => s.unsubscribe());
    }

    addEventListener(element: EventTarget, event: string, handler: EventListenerOrEventListenerObject) {
        element.addEventListener(event, handler);
        this._subscriptions.push({ unsubscribe: () => element.removeEventListener(event, handler) });
    }

    subscribe<T>(event: string, fn: (data: T) => void) {
        return appSubscribe(event, fn);
    }

    subscribeInterval(fn: Function, ms: number): void {
        const interval = setInterval(fn, ms);
        this._subscriptions.push({ unsubscribe: () => clearInterval(interval) });
    }

    translate(key: string, params?: any): string {
        return appDomain.IRequestTranslation.translate(key, params);
    }

    navigateTo(url: string, params: any = {}): void {
        appDomain.INavigator.navigateTo(url, params);
    }
}
